module.exports = __webpack_public_path__ + "img/success.67c9719b.png";